/* ===========================================================
   Elvvora Theme JS
   Cart drawer uses Shopify's real Cart AJAX API (/cart/add.js,
   /cart.js, /cart/change.js) — no in-memory mock data.
   =========================================================== */

document.addEventListener('DOMContentLoaded', function () {

  /* ---------- Cart Drawer open/close ---------- */
  const cartDrawer = document.getElementById('cartDrawer');
  const cartOverlay = document.getElementById('cartOverlay');
  const cartIconBtn = document.getElementById('cartIconBtn');
  const cartCloseBtn = document.getElementById('cartCloseBtn');

  function openCart() {
    cartDrawer.classList.add('open');
    cartOverlay.classList.add('open');
    renderCart();
  }
  function closeCart() {
    cartDrawer.classList.remove('open');
    cartOverlay.classList.remove('open');
  }
  if (cartIconBtn) cartIconBtn.addEventListener('click', openCart);
  if (cartCloseBtn) cartCloseBtn.addEventListener('click', closeCart);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

  /* ---------- Mobile menu open/close ---------- */
  const mobileMenuBtn = document.getElementById('mobileMenuBtn');
  const mobileMenuDrawer = document.getElementById('mobileMenuDrawer');
  const mobileMenuOverlay = document.getElementById('mobileMenuOverlay');
  const mobileMenuClose = document.getElementById('mobileMenuClose');

  function openMobileMenu() {
    mobileMenuDrawer.classList.add('open');
    mobileMenuOverlay.classList.add('open');
  }
  function closeMobileMenu() {
    mobileMenuDrawer.classList.remove('open');
    mobileMenuOverlay.classList.remove('open');
  }
  if (mobileMenuBtn) mobileMenuBtn.addEventListener('click', openMobileMenu);
  if (mobileMenuClose) mobileMenuClose.addEventListener('click', closeMobileMenu);
  if (mobileMenuOverlay) mobileMenuOverlay.addEventListener('click', closeMobileMenu);

  /* ---------- Render cart from Shopify's real cart ---------- */
  window.renderCart = function () {
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        const itemsEl = document.getElementById('cartItems');
        const countEl = document.getElementById('cartCount');
        const subtotalEl = document.getElementById('cartSubtotal');

        countEl.textContent = cart.item_count;
        countEl.hidden = cart.item_count === 0;

        if (cart.items.length === 0) {
          itemsEl.innerHTML = '<div class="cart-empty">Your cart is empty.<br>Add something delicious!</div>';
          subtotalEl.textContent = formatMoney(0);
          return;
        }

        itemsEl.innerHTML = cart.items.map(item => `
          <div class="cart-item">
            <img src="${item.image}" alt="${item.product_title}">
            <div class="cart-item-info">
              <h5>${item.product_title}${item.variant_title && item.variant_title !== 'Default Title' ? ' (' + item.variant_title + ')' : ''}</h5>
              <div class="cart-item-price">${formatMoney(item.final_price)}</div>
              <div class="cart-item-qty">
                <button onclick="changeCartLine(${item.key ? "'" + item.key + "'" : item.line}, ${item.quantity - 1})">−</button>
                <span>${item.quantity}</span>
                <button onclick="changeCartLine(${item.key ? "'" + item.key + "'" : item.line}, ${item.quantity + 1})">+</button>
                <span class="cart-remove" onclick="changeCartLine(${item.key ? "'" + item.key + "'" : item.line}, 0)">Remove</span>
              </div>
            </div>
          </div>
        `).join('');

        subtotalEl.textContent = formatMoney(cart.total_price);
      })
      .catch(err => console.error('Cart fetch failed:', err));
  };

  /* ---------- Change / remove line item ---------- */
  window.changeCartLine = function (lineOrKey, quantity) {
    const body = typeof lineOrKey === 'string'
      ? { id: lineOrKey, quantity: quantity }
      : { line: lineOrKey, quantity: quantity };

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(res => res.json())
      .then(() => renderCart())
      .catch(err => console.error('Cart change failed:', err));
  };

  /* ---------- Add to cart (used by product forms + related product cards) ---------- */
  window.addToCartAjax = function (variantId, quantity) {
    quantity = quantity || 1;
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: quantity }] })
    })
      .then(res => {
        if (!res.ok) return res.json().then(err => { throw err; });
        return res.json();
      })
      .then(() => {
        openCart();
      })
      .catch(err => {
        console.error('Add to cart failed:', err);
        alert(err.description || 'Could not add this item to your cart.');
      });
  };

  /* ---------- Money formatter (basic INR fallback if Shopify.formatMoney unavailable) ---------- */
  function formatMoney(cents) {
    if (window.Shopify && Shopify.formatMoney && window.themeMoneyFormat) {
      return Shopify.formatMoney(cents, window.themeMoneyFormat);
    }
    return '₹' + (cents / 100).toFixed(0);
  }

  /* ---------- Product page: variant/size pill selector ---------- */
  document.querySelectorAll('[data-product-form]').forEach(form => {
    const pills = form.querySelectorAll('.size-pill');
    const priceDisplay = document.querySelector('[data-price-display]');
    const variantIdInput = form.querySelector('[data-variant-id-input]');
    const addBtn = form.querySelector('[data-add-to-cart-btn]');
    const qtyInput = form.querySelector('[data-qty-input]');

    pills.forEach(pill => {
      pill.addEventListener('click', function () {
        if (this.disabled) return;
        pills.forEach(p => p.classList.remove('active'));
        this.classList.add('active');

        const variantId = this.dataset.variantId;
        const variantPrice = this.dataset.variantPrice;
        const available = this.dataset.available === 'true';

        variantIdInput.value = variantId;
        if (priceDisplay && variantPrice) priceDisplay.textContent = formatMoney(parseInt(variantPrice, 10));

        if (addBtn) {
          addBtn.disabled = !available;
          addBtn.textContent = available ? 'Add to Cart' : 'Sold Out';
        }
      });
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      const variantId = variantIdInput.value;
      const qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
      if (!variantId) return;
      addToCartAjax(variantId, qty);
    });
  });

  /* ---------- Quantity stepper on product page ---------- */
  document.querySelectorAll('[data-qty-decrease]').forEach(btn => {
    btn.addEventListener('click', function () {
      const input = this.parentElement.querySelector('[data-qty-input]');
      input.value = Math.max(1, parseInt(input.value, 10) - 1);
    });
  });
  document.querySelectorAll('[data-qty-increase]').forEach(btn => {
    btn.addEventListener('click', function () {
      const input = this.parentElement.querySelector('[data-qty-input]');
      input.value = parseInt(input.value, 10) + 1;
    });
  });

  /* ---------- Related product card quick-add ---------- */
  document.querySelectorAll('[data-quick-add-variant]').forEach(btn => {
    btn.addEventListener('click', function () {
      addToCartAjax(this.dataset.quickAddVariant, 1);
    });
  });

  /* ---------- Product gallery thumbnail swap ---------- */
  document.querySelectorAll('.thumb').forEach(thumb => {
    thumb.addEventListener('click', function () {
      const mainImg = document.querySelector('.gallery-main img');
      const fullSrc = this.dataset.fullImage;
      if (mainImg && fullSrc) mainImg.src = fullSrc;
      document.querySelectorAll('.thumb').forEach(t => t.classList.remove('active'));
      this.classList.add('active');
    });
  });

  /* ---------- Product page tabs ---------- */
  document.querySelectorAll('.tab-btn').forEach(btn => {
    btn.addEventListener('click', function () {
      const tabId = this.dataset.tab;
      document.querySelectorAll('.tab-btn').forEach(b => b.classList.remove('active'));
      document.querySelectorAll('.tab-panel').forEach(p => p.classList.remove('active'));
      this.classList.add('active');
      document.getElementById('tab-' + tabId).classList.add('active');
    });
  });

  /* ---------- Collection page filter ---------- */
  const filterBtns = document.querySelectorAll('.filter-btn');
  if (filterBtns.length) {
    const cards = document.querySelectorAll('[data-product-category]');
    const resultCount = document.getElementById('resultCount');
    filterBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        filterBtns.forEach(b => b.classList.remove('active'));
        btn.classList.add('active');
        const filter = btn.dataset.filter;
        let visible = 0;
        cards.forEach(card => {
          const match = filter === 'all' || card.dataset.productCategory === filter;
          card.style.display = match ? 'flex' : 'none';
          if (match) visible++;
        });
        if (resultCount) {
          resultCount.textContent = filter === 'all'
            ? 'Showing all ' + visible + ' products'
            : 'Showing ' + visible + ' ' + filter + ' products';
        }
      });
    });
  }

  /* Initial cart badge sync on page load */
  renderCart();
});
